// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e78ad9fb","553":"787aba5b","977":"d13034ab"}[chunkId] + ".chunk.js";
};